import DialogSpin from "@/components/dialog/DialogSpin";
import UIMiniLoader from "@/components/ui/UIMiniLoader";
import SessionMixin from "@/mixins/session.mixin";
import {mapActions} from "vuex";
import {validate as IsUUID} from 'uuid';

export default {

  mixins: [
    SessionMixin
  ],

  methods: {
    ...mapActions(['setQueryObject', 'setHeaderTitle']),
    onKeydown(e) {
      console.log('kd')
      if (e.code === 'Enter' || e.code === 'NumpadEnter') {
        e.preventDefault();
      }
    },
    buildQueryObject() {
      if (this.$route.query.x) {
        let queryObject = {...(this.$route.params)};
        const entries = this.$route.query.x.split('|');

        for (const e of entries) {
          const [k, v] = e.split('=');
          queryObject[k] = v;
        }

        if (this.$route.query.ssoCookieTokenValue) {
          if (IsUUID(this.$route.query.ssoCookieTokenValue)) {
            queryObject.ssoCookieTokenValue = this.$route.query.ssoCookieTokenValue;
          } else {
            this.$router.replace({query: {ssoCookieTokenValue: undefined, x: this.$route.query.x}});
          }
        }

        this.setQueryObject(queryObject);
      } else {
        if (this.$route.name === 'POBR-Auth') {
          this.navigateToNotFound();
          this.notifyCustomError('Neveljavni parametri.');
        } else {
          this.setQueryObject({...this.$route.params});
        }
      }
    },
    async fetchHeaderLabel(queryObject) {
      try {
        const fetchHeaderLabelResponse = await this.$http.post('template/title', {
          id: queryObject.id,
          tid: queryObject.tid
        });

        document.title = fetchHeaderLabelResponse.data.title + ' - Triglav Zdravje';

        this.setHeaderTitle(fetchHeaderLabelResponse.data.title);
      } catch (e) {
        return await this.handleError(e, this.fetchHeaderLabel.bind(this));
      }
    },
    showLoadingBig() {
      this.$modal.show(DialogSpin, undefined, {
        clickToClose: false,
        classes: ["dialog-spin-container"],
        width: "280px",
        height: "280px",
        styles: "background: transparent; padding: 0; border-radius: 20px",
      });
    },
    hideLoading() {
      this.$modal.hideAll();
    },
    showLoadingMini() {
      this.$modal.show(UIMiniLoader, undefined, {
        clickToClose: false,
        classes: ["ui-mini-loader-container"],
        width: "50",
        height: "50",
        styles: "background: transparent; padding: 0; border-radius: 20px",
      });
    },
    hideAllNotify() {
      this.$notify({
        clean: true
      });
    },
    notifySuccessQuick(message) {
      this.$notify({
        type: 'success',
        duration: 2500,

        text: message,
      });
    },
    notifySuccess(message) {
      this.$notify({
        type: 'success',
        duration: 10000,

        text: message,
      });
    },
    notifyCustomError(message) {
      this.$notify({
        type: 'error',
        duration: 10000,

        text: message
      });
    },
    navigateToNotFound() {
      this.$router.push('/');
    },
    async handleError(e, callback) {
      // callback - where the handleError was called from.
      // Used to handle expired session tokens - after getting a new session token, call the intended function again without interrupting the user.

      this.$modal.hideAll();

      if (e.code && e.code === 'ERR_NETWORK') {
        if (e.config && e.config.url && !e.config.url.startsWith(process.env.VUE_APP_API)) {
          return;
        }

        this.$notify({
          type: 'error',
          duration: 10000,

          title: 'Napaka',
          text: 'Napaka pri povezavi do strežnika.',
        });
      } else if (e && e.response && e.response.status === 400 && e.response.data && e.response.data.message === 'SESSION_EXPIRED') {
        console.log('current token has expired.');

        try {
          await this.getSessionToken();
        } catch {
          return;
        }

        return callback();
      } else if (e.response && typeof e.response.data === 'object') {
        this.$notify({
          type: 'error',
          duration: 10000,

          title: 'Napaka',
          text: e.response.data.message,
        });
      }

      return false;
    },
    dateToString(date) {
      if (!(date instanceof Date)) date = new Date(date);

      const [year, month, day] = [
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
      ];

      return `${day}.${month + 1}.${year}`;
    },
    onTZZCall() {
      window.open("tel:+386802664");
    },
    async logout() {
      try {
        const logoutResponse = await this.$http.get('/auth/logout');

        if (logoutResponse.data.redirectTo) {
          if (logoutResponse.data.redirectTo.iTriglavLogout) {
            this.$store.dispatch('iTriglavLogout');
          } else {
            let path;
            let mvQuery = {...logoutResponse.data.redirectTo.params};

            if (logoutResponse.data.redirectTo.toAuth) {
              path = 'enter';
            }

            if (this.queryObject.wv) {
              mvQuery.wv = this.queryObject.wv;
            }

            const mvQueryString = Object.keys(mvQuery).map(k => `${k}=${mvQuery[k]}`).join('|');

            // Hard refresh here because we want to reset everything - dirty but works
            window.localStorage.removeItem('pobr-auth');
            window.location.href = `${window.location.protocol || 'https:'}//${window.location.host}/${path}${mvQueryString.length > 0 ? `?x=${mvQueryString}` : ''}`;
          }
        }
      } catch (e) {
        return;
      }
    },
    async onIdentification(data) {
      try {
        this.showLoadingBig();
        await this.$http.post('/pobr/soglasje-sdd-eracun/identification', data);
        this.hideLoading();
      } catch (e) {
        return;
      }
    }
  }
}
